import styled from "styled-components";

export const Styles = styled.div`
  .currencies {
    display: flex;
    align-items: center;

    .tab-message {
      padding: 30px 0;
      text-align: center;
      font-size: 16px;
      color: #5b616e;

      &.error {
        color: #c62828;
      }
    }

    .refresh-error {
      margin-bottom: 12px;
      color: #c62828;
      font-family: IRANSans;
      font-size: 13px;
      text-align: center;
    }

    .asset-content {
      padding: 0 120px;
      @media screen and (max-width: 1440px) {
        padding: 0 50px;
      }
      @media screen and (max-width: 320px) {
        padding: 20px 0;
      }
    }
  }
`;
